/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import { Spin } from 'antd';
import '../index.less';

// 页尾部分
import Footer from '../../layout/Footer';
import { FooterDataSource } from '../../layout/data.source.js';

export default class OSCA extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  componentDidMount() {
    this.setState({ loading: true });

    // 接口请求
    const iframe = this.refs.Iframe;

    if (iframe) {
      // 兼容处理
      if (iframe.attachEvent) {
        // IE
        iframe && iframe.attachEvent("onload", () => {
          this.setState({
            loading: false
          });
        });
      } else {
        // 非IE
        iframe.onload = () => {
          this.setState({
            loading: false
          });
        };
      }
    }
  };

  render() {
    const { loading } = this.state;

    const children = [
      <Spin id="Iframe" key="Iframe" size="large" spinning={loading} className="global-loading-style" tip="Loading...">
        <iframe 
          ref="Iframe"
          title="data"
          className="data-iframe-style"
          src="https://yanglab.westlake.edu.cn/software/osca/#Overview" 
        >
        </iframe>
      </Spin>,
      <Footer 
        id="Footer"
        key="Footer"
        dataSource={FooterDataSource} 
      />
    ];
    
    return (
      <div
        className="templates-wrapper"
        ref={(d) => {
          this.dom = d;
        }}
      >
        {children}
      </div>
    );
  }
}
